import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { StrategyHelpers } from '../../service/StrategyHelpers/StrategyHelpers';
import { CampaignStrategy } from '../../typings/domain';
import { TextCell } from '../TextCell/TextCell';

export interface GridCampignStrategyCellProps {
    strategy: CampaignStrategy;
    isBidCorrectionSearchEnabled?: boolean;
}

export class GridCampignStrategyCell extends React.Component<
    GridCampignStrategyCellProps
> {
    render() {
        const { strategy, isBidCorrectionSearchEnabled } = this.props;

        return (
            <div className={Bem.cls('grid-campaign-strategy-cell')}>
                <TextCell>
                    {StrategyHelpers.getTitle(
                        strategy.type,
                        strategy.platform,
                        isBidCorrectionSearchEnabled
                    )}
                </TextCell>
            </div>
        );
    }
}
